(function () {
  if (window.MosaicPrelaunch) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var revealObserver = null;

  function initChrome(scope) {
    var chrome = scope.querySelector('[data-mxp-chrome]');
    if (!chrome || chrome.dataset.mxpReady === 'true') return;
    chrome.dataset.mxpReady = 'true';

    var bar = chrome.querySelector('[data-mxp-announce]');
    var nav = chrome.querySelector('[data-mxp-nav]');

    function measure() {
      var height = bar ? bar.offsetHeight : 0;
      document.documentElement.style.setProperty('--mxp-bar-h', height + 'px');
    }

    function onScroll() {
      if (nav) nav.classList.toggle('is-scrolled', window.scrollY > 24);
    }

    measure();
    onScroll();
    window.addEventListener('resize', measure);
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  function hasLightBackground(el) {
    while (el && el !== document.body) {
      var style = window.getComputedStyle(el);
      // Mosaic's dark sections are painted with gradients; light ones with solid colors.
      if (style.backgroundImage.indexOf('gradient') !== -1) return false;
      var rgba = style.backgroundColor.match(/[\d.]+/g);
      if (rgba && (rgba.length < 4 || parseFloat(rgba[3]) > 0.5)) {
        var luminance = (0.2126 * rgba[0] + 0.7152 * rgba[1] + 0.0722 * rgba[2]) / 255;
        return luminance > 0.6;
      }
      el = el.parentElement;
    }
    return false;
  }

  function initNavTone() {
    document.querySelectorAll('[data-ig-localnav]').forEach(initNavToneFor);
  }

  function initNavToneFor(nav) {
    if (nav.dataset.mxpTone === 'true') return;
    nav.dataset.mxpTone = 'true';

    var queued = false;

    function update() {
      queued = false;
      var probeY = nav.getBoundingClientRect().bottom + 1;
      var probe = probeY < window.innerHeight ? document.elementFromPoint(4, probeY) : null;
      nav.classList.toggle('is-light', hasLightBackground(probe));
    }

    function queue() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    update();
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
  }

  function initRotator(root) {
    if (root.dataset.mxpReady === 'true') return;
    root.dataset.mxpReady = 'true';

    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mxp-slide]'));
    var ghosts = Array.prototype.slice.call(root.querySelectorAll('[data-mxp-ghost]'));
    var dots = Array.prototype.slice.call(root.querySelectorAll('[data-mxp-dot]'));
    var caption = root.querySelector('[data-mxp-caption]');
    var toggle = root.querySelector('[data-mxp-toggle]');
    var count = slides.length;
    var delay = parseInt(root.dataset.interval, 10) || 5000;
    var index = 0;
    var timer = null;
    var playing = !reduceMotion.matches;
    var held = false;

    if (count === 0) return;

    function show(next) {
      index = (next + count) % count;

      slides.forEach(function (slide, i) {
        var active = i === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', active ? 'false' : 'true');
      });

      ghosts.forEach(function (ghost, offset) {
        var target = (index + offset + 1) % count;
        ghost.hidden = count < offset + 2;
        ghost.querySelectorAll('[data-mxp-ghost-slide]').forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === target);
        });
      });

      dots.forEach(function (dot, i) {
        if (i === index) {
          dot.setAttribute('aria-current', 'true');
        } else {
          dot.removeAttribute('aria-current');
        }
      });

      if (caption) caption.textContent = slides[index].dataset.caption || '';
    }

    function stop() {
      window.clearInterval(timer);
      timer = null;
    }

    function start() {
      stop();
      if (playing && !held && count > 1 && !document.hidden) {
        timer = window.setInterval(function () {
          show(index + 1);
        }, delay);
      }
    }

    function syncToggle() {
      if (!toggle) return;
      toggle.setAttribute('aria-pressed', playing ? 'false' : 'true');
      toggle.setAttribute('aria-label', playing ? toggle.dataset.labelPause : toggle.dataset.labelPlay);
    }

    dots.forEach(function (dot, i) {
      dot.addEventListener('click', function () {
        show(i);
        start();
      });
    });

    if (toggle) {
      toggle.addEventListener('click', function () {
        playing = !playing;
        syncToggle();
        start();
      });
    }

    root.addEventListener('mouseenter', function () {
      held = true;
      stop();
    });
    root.addEventListener('mouseleave', function () {
      held = false;
      start();
    });
    root.addEventListener('focusin', function () {
      held = true;
      stop();
    });
    root.addEventListener('focusout', function (event) {
      if (root.contains(event.relatedTarget)) return;
      held = false;
      start();
    });
    document.addEventListener('visibilitychange', start);

    root._mxpRotator = {
      show: show,
      stop: stop,
      pause: function () {
        playing = false;
        syncToggle();
        stop();
      }
    };

    show(0);
    syncToggle();
    start();
  }

  function initReveal(scope) {
    var items = Array.prototype.slice.call(scope.querySelectorAll('[data-mxp-reveal]:not(.is-revealed)'));
    if (!items.length) return;

    if (designMode || reduceMotion.matches || !('IntersectionObserver' in window)) {
      items.forEach(function (item) {
        item.classList.add('is-revealed');
      });
      return;
    }

    document.documentElement.classList.add('mxp-motion');

    if (!revealObserver) {
      revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('is-revealed');
            revealObserver.unobserve(entry.target);
          });
        },
        { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
      );
    }

    items.forEach(function (item) {
      revealObserver.observe(item);
    });
  }

  function initSuccess(scope) {
    var success = scope.querySelector('[data-mxp-success]');
    if (!success || designMode || success.dataset.mxpReady === 'true') return;
    success.dataset.mxpReady = 'true';
    success.focus({ preventScroll: true });
    success.scrollIntoView({ behavior: reduceMotion.matches ? 'auto' : 'smooth', block: 'center' });
  }

  function init(scope) {
    scope = scope || document;
    initNavTone();
    initChrome(scope);
    scope.querySelectorAll('[data-mxp-rotator]').forEach(initRotator);
    initReveal(scope);
    initSuccess(scope);
  }

  window.MosaicPrelaunch = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    if (event.target && event.target.querySelector) init(event.target);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    if (!event.target || !event.target.querySelectorAll) return;
    event.target.querySelectorAll('[data-mxp-rotator]').forEach(function (root) {
      if (root._mxpRotator) root._mxpRotator.stop();
    });
  });

  document.addEventListener('shopify:block:select', function (event) {
    var slide = event.target;
    if (!slide || !slide.hasAttribute || !slide.hasAttribute('data-mxp-slide')) return;
    var root = slide.closest('[data-mxp-rotator]');
    if (!root || !root._mxpRotator) return;
    var slides = Array.prototype.slice.call(root.querySelectorAll('[data-mxp-slide]'));
    root._mxpRotator.pause();
    root._mxpRotator.show(slides.indexOf(slide));
  });
})();
